module.exports = __webpack_public_path__ + "static/media/left-quote.1b06aa9f.svg";